import { Plan } from './components/Plan';
import withTableController from '../../../../../HOC/tableController/withTableControllerForAdminEvaluation';

const Table24 = withTableController(({ planing, handlePlaning, status }) => (
  <Plan planing={planing} handlePlaning={handlePlaning} status={status} />
));

export default Table24;
